<template>
  <v-card class="mt-4">
    <v-toolbar color="primary h5 text-white">{{ item.title }}</v-toolbar>
    <v-card-text class="pa-4">
      <v-simple-table class="table-compact">
        <template v-slot:default>
          <thead>
            <th class="" v-for="(head, i) in item.data.header" :key="i">
              {{ head }}
            </th>
          </thead>
          <tbody v-if="item.data.body.length > 0">
            <tr v-for="(data, index) in item.data.body" :key="index">
              <td class="ps-1" v-for="(el, j) in data" :key="j">
                <div v-html="el"></div>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr class="h-75px">
              <td
                :colspan="item?.data?.header?.length"
                class="text-center pt-4"
              >
                <span class="second-text">No Data Available!</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "PopUpTable",
  props: ["item"],
};
</script>

<style></style>
